import { Component, Input } from '@angular/core';
import { ImageInterface } from 'src/app/types/image';

interface MultiImageInterface {
  items: ImageInterface;
  template: string;
}

@Component({
  selector: 'app-multiimage',
  templateUrl: './multiimage.component.html',
  styleUrls: ['./multiimage.component.scss'],
})
export class MultiImageComponent {
  columnCount: number;

  @Input() node: MultiImageInterface;

  ngOnInit() {
    if (this.node?.template)
      this.columnCount = 12 / parseInt(this.node.template.replace('grid-', ''));
  }
}
